// extracted by mini-css-extract-plugin
module.exports = {"locationIcon":"location_input-module_locationIcon_0e775"};